import { render, staticRenderFns } from "./editMenuGroup.vue?vue&type=template&id=2a3b2be4"
import script from "./editMenuGroup.vue?vue&type=script&lang=js"
export * from "./editMenuGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports